import React from 'react';
import { reviewChecklist } from '../../data/samplePrompts';
export function ReviewChecklist() {
  return <div className="mt-10" data-id="element-263" data-mp="29f68tmotiq73">
      <h3 className="text-center font-display text-xl font-black uppercase text-plum sm:text-2xl" data-id="element-264" data-mp="29eehio297emm">Before you send it</h3>
      <p className="mt-2 text-center text-sm text-plum/60" data-id="element-265" data-mp="2dfq7iup1i1vc">Use this review checklist to assess the AI-generated draft.</p>

      <ol className="mt-6 divide-y divide-grape-soft/30 border-y border-grape-soft/40" data-id="element-266" data-mp="1lqn4fi8w2xka">
        {reviewChecklist.map((item, i) => <li key={item.title} className="flex gap-4 py-4" data-id="element-267" data-mp="1psruy841je2p" data-mpi={i}>
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-plum text-xs font-black text-grape-soft" data-id="element-268" data-mp="1urbigcya8xx6">{i + 1}</span>
            <div data-id="element-269" data-mp="1zjcohh4uxser">
              <p className="text-sm font-bold text-plum" data-id="element-270" data-mp="1zjuwtc4snx31">{item.title}</p>
              <p className="mt-0.5 text-sm leading-relaxed text-plum/65" data-id="element-271" data-mp="121mcdl6pu7op">{item.desc}</p>
            </div>
          </li>)}
      </ol>

      <p className="mt-5 text-center text-sm font-semibold text-plum/75" data-id="element-272" data-mp="16z4i72pfs6sh">
        AI can help organize information. You remain responsible for verifying the output and ensuring that it meets your organization's standards.
      </p>
    </div>;
}